import React from 'react'
import { Helmet } from 'react-helmet'

const Head = () => {
	return (
		<Helmet>
			<title>Guruh yaratish</title>
		</Helmet>
	)
}

export default Head
